import useSuperAdminApplianceManufacturers from '../data/appliance/useSuperAdminApplianceManufacturers';
import useSuperAdminApplianceModels from '../data/appliance/useSuperAdminApplianceModels';
import useSuperAdminApplianceTypes from '../data/appliance/useSuperAdminApplianceTypes';

const useSuperAdminApplianceTypeLookup = () => {
  const { superAdminApplianceTypes } = useSuperAdminApplianceTypes();

  const lookup = (typeId: string) =>
    superAdminApplianceTypes.data?.find((m) => m.id === typeId);

  return {
    isLoading: superAdminApplianceTypes.isLoading,
    lookup,
  };
};

const useSuperAdminApplianceManufacturerLookup = () => {
  const { superAdminApplianceManufacturers } =
    useSuperAdminApplianceManufacturers();

  const lookup = (manufacturerId: string) =>
    superAdminApplianceManufacturers.data?.find((m) => m.id === manufacturerId);

  return {
    isLoading: superAdminApplianceManufacturers.isLoading,
    lookup,
  };
};

const useSuperAdminHardwareModelLookup = () => {
  const { superAdminApplianceModels } = useSuperAdminApplianceModels();

  const lookup = (modelId: string) =>
    superAdminApplianceModels.data?.find((m) => m.id === modelId);

  return {
    isLoading: superAdminApplianceModels.isLoading,
    lookup,
  };
};

export const useSuperAdminApplianceLookups = () => {
  const { isLoading: typesLoading, lookup: typeLookup } =
    useSuperAdminApplianceTypeLookup();

  const { isLoading: manufacturersLoading, lookup: manufacturerLookup } =
    useSuperAdminApplianceManufacturerLookup();

  const { isLoading: modelsLoading, lookup: modelLookup } =
    useSuperAdminHardwareModelLookup();

  const isLoading = manufacturersLoading || typesLoading || modelsLoading;

  return {
    isLoading,
    typeLookup,
    manufacturerLookup,
    modelLookup,
  };
};
